import { render, staticRenderFns } from "./AdFootOrderComplete.vue?vue&type=template&id=5e90a580&scoped=true"
import script from "./AdFootOrderComplete.vue?vue&type=script&lang=ts"
export * from "./AdFootOrderComplete.vue?vue&type=script&lang=ts"
import style0 from "./AdFootOrderComplete.vue?vue&type=style&index=0&id=5e90a580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e90a580",
  null
  
)

export default component.exports